import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "w-100 d-flex justify-content-between" }
const _hoisted_3 = {
  class: "row",
  style: {"margin-top":"45px"}
}
const _hoisted_4 = { class: "col-lg-4 col-md-4 pb-3" }
const _hoisted_5 = { class: "col-lg-4 col-md-4 pb-3" }
const _hoisted_6 = { class: "col-lg-4 col-md-4 pb-3" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex flex-column gap-5"
}
const _hoisted_8 = { class: "w-100 bg-white p-5" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "text-capitalize" }
const _hoisted_11 = {
  key: 0,
  class: "red-flag ms-3"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-flag-fill text-danger" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_15 = { class: "text-capitalize" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "text-capitalize" }
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = {
  key: 0,
  class: "d-flex flex-column gap-5"
}
const _hoisted_20 = { class: "w-100 bg-white p-5" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { class: "text-capitalize" }
const _hoisted_23 = {
  key: 0,
  class: "red-flag ms-3"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-flag-fill text-danger" }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_27 = { class: "text-capitalize" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "text-capitalize" }
const _hoisted_30 = { class: "d-flex align-items-center" }
const _hoisted_31 = {
  key: 0,
  class: "d-flex flex-column gap-5"
}
const _hoisted_32 = { class: "w-100 bg-white p-5" }
const _hoisted_33 = { class: "d-flex align-items-center" }
const _hoisted_34 = { class: "text-capitalize ms-3" }
const _hoisted_35 = { class: "text-capitalize" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Header = _resolveComponent("Header")!
  const _component_WidgetCountSummary = _resolveComponent("WidgetCountSummary")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_TenantAvatar = _resolveComponent("TenantAvatar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_UserAvatar = _resolveComponent("UserAvatar")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Breadcrumb, { items: _ctx.breadcrumbs }, null, 8, ["items"])
    ]),
    _createVNode(_component_Header, { agency: _ctx.agency }, null, 8, ["agency"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_WidgetCountSummary, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showTableData(0))),
          icon: "fas fa-star",
          text: "Tenants Reviewed",
          count: _ctx.agency?.review_report_count,
          color: "red"
        }, null, 8, ["count"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_WidgetCountSummary, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTableData(1))),
          icon: "fab fa-telegram-plane",
          text: "Tenant Reference Requested",
          count: _ctx.agency?.reference_request_count,
          color: "blue"
        }, null, 8, ["count"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_WidgetCountSummary, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showTableData(2))),
          icon: "fas fa-user",
          text: "Users",
          count: _ctx.agency?.user_count,
          color: "green"
        }, null, 8, ["count"])
      ])
    ]),
    _createVNode(_component_Card, { style: {"margin-top":"35px","margin-bottom":"50px"} }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.sectionTitle), 1)
      ]),
      default: _withCtx(() => [
        (_ctx.activeMenu == 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.loadingReferences)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_el_skeleton, {
                        animated: "",
                        row: "5"
                      })
                    ])
                  ]))
                : (_openBlock(), _createBlock(_component_DataTable, {
                    key: 1,
                    "table-data": _ctx.reviewedTable.items,
                    "table-header": _ctx.reviewedTableHeaders,
                    ordering: _ctx.reviewedTable.ordering,
                    "onClick:row": _ctx.viewReport,
                    "row-class": "table-hover"
                  }, {
                    "cell-name": _withCtx(({ row: item }) => [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_router_link, {
                          to: {
                  name: 'view-tenant-reference',
                  params: {
                    tenant_id: item.tenant.id,
                    tenant_ref_id: item.reference_no,
                  },
                },
                          class: "d-flex align-items-center",
                          style: {"color":"inherit !important"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_TenantAvatar, {
                              radius: true,
                              id: item.tenant.user.id,
                              style: {"margin-right":"15px"}
                            }, null, 8, ["id"]),
                            _createElementVNode("span", _hoisted_10, _toDisplayString(item.tenant.first_name) + " " + _toDisplayString(item.tenant.last_name), 1),
                            (item.is_flagged === 'yes')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _hoisted_13))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ]),
                    "cell-agency": _withCtx(({ row: item }) => [
                      (item.user.business_name)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("span", _hoisted_15, _toDisplayString(item.user.business_name), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_16, "Not Specified"))
                    ]),
                    "cell-date": _withCtx(({ row: item }) => [
                      _createTextVNode(_toDisplayString(_ctx.$filters.formatDate(item.date, 'aus')), 1)
                    ]),
                    "cell-agent_name": _withCtx(({ row: item }) => [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(item.user.first_name) + " " + _toDisplayString(item.user.last_name), 1)
                    ]),
                    "cell-rating": _withCtx(({ row: item }) => [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_el_form_item, { class: "mb-0" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_rate, {
                              class: "rating-size",
                              "model-value": 1,
                              disabled: "",
                              max: "1"
                            })
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(parseFloat(item.average_rating).toFixed(1)), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["table-data", "table-header", "ordering", "onClick:row"]))
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.activeMenu == 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.loadingRequested)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_el_skeleton, {
                        animated: "",
                        row: "5"
                      })
                    ])
                  ]))
                : (_openBlock(), _createBlock(_component_DataTable, {
                    key: 1,
                    "table-data": _ctx.requestedTable.items,
                    "table-header": _ctx.requestedTableHeaders,
                    "enable-items-per-page-dropdown": true
                  }, {
                    "cell-name": _withCtx(({ row: item }) => [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_router_link, {
                          to: {
                  name: 'view-tenant-reference',
                  params: {
                    tenant_id: item.tenant.id,
                    tenant_ref_id: item.reference_no,
                  },
                },
                          class: "d-flex align-items-center",
                          style: {"color":"inherit !important"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_TenantAvatar, {
                              radius: true,
                              id: item.tenant.user.id,
                              style: {"margin-right":"15px"}
                            }, null, 8, ["id"]),
                            _createElementVNode("span", _hoisted_22, _toDisplayString(item.tenant.first_name) + " " + _toDisplayString(item.tenant.last_name), 1),
                            (item.is_flagged === 'yes')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_23, _hoisted_25))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ]),
                    "cell-agency": _withCtx(({ row: item }) => [
                      (item.user.business_name)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("span", _hoisted_27, _toDisplayString(item.user.business_name), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_28, "Not Specified"))
                    ]),
                    "cell-date": _withCtx(({ row: item }) => [
                      _createTextVNode(_toDisplayString(_ctx.$filters.formatDate(item.date, 'aus')), 1)
                    ]),
                    "cell-requested_date": _withCtx(({ row: item }) => [
                      _createTextVNode(_toDisplayString(_ctx.$filters.formatDate(item.requested_date, 'aus')), 1)
                    ]),
                    "cell-requested_by": _withCtx(({ row: item }) => [
                      _createElementVNode("span", _hoisted_29, _toDisplayString(item.requested_by), 1)
                    ]),
                    "cell-rating": _withCtx(({ row: item }) => [
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_el_form_item, { class: "mb-0" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_rate, {
                              class: "rating-size",
                              "model-value": 1,
                              disabled: "",
                              max: "1"
                            })
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(parseFloat(item.average_rating).toFixed(1)), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["table-data", "table-header"]))
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.activeMenu == 2)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (!_ctx.table.items.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_el_skeleton, {
                        animated: "",
                        row: "5"
                      })
                    ])
                  ]))
                : (_openBlock(), _createBlock(_component_DataTable, {
                    key: 1,
                    "table-data": _ctx.table.items,
                    "table-header": _ctx.userTableHeaders,
                    "enable-items-per-page-dropdown": true
                  }, {
                    "cell-user": _withCtx(({ row: item }) => [
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_component_UserAvatar, {
                          acronym: _ctx.getAcronym(item.user),
                          radius: true,
                          class: "me-3",
                          id: item.id,
                          url: item.avatar_src
                        }, null, 8, ["acronym", "id", "url"]),
                        _createElementVNode("span", _hoisted_34, _toDisplayString(item.first_name) + " " + _toDisplayString(item.last_name), 1)
                      ])
                    ]),
                    "cell-role": _withCtx(({ row: item }) => [
                      _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.getRole(item.roles[0])), 1)
                    ]),
                    _: 1
                  }, 8, ["table-data", "table-header"]))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}